var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "company-area no-top" }, [
    _vm.companyName
      ? _c("a", { staticClass: "company-name" }, [
          _vm._v("\n    " + _vm._s(_vm.companyName) + "\n  "),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "h1",
      { staticClass: "company-title" },
      [
        _vm._v("\n    " + _vm._s(_vm.title) + "\n    "),
        _c("job-employment-status-sp", {
          attrs: { "employment-status": _vm.employmentStatus },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "company-day" }, [
      _c("p", { staticClass: "icon" }, [
        _c("img", {
          staticClass: "new-icon",
          attrs: {
            src: _vm.userOfferImageUrlForSp + "/icon_company_new.png",
            alt: "NEW",
          },
        }),
        _vm._v(" "),
        _vm.isSimple && !_vm.isOriginalEntryForm
          ? _c("img", {
              staticClass: "simple-interview-icon",
              attrs: {
                src: _vm.userOfferImageUrlForSp + "/icon_company_simple.png",
                alt: "シンプル応募",
              },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "limit" }, [
        _vm._v("\n      掲載期間 yyyy/mm/dd〜yyyy/mm/dd\n    "),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }